import React, { useState } from "react";
import { useDebounce } from "use-debounce";

import IconButton from "../../../commons/IconButton";

const Action = ({ title, icon, disabled, onExecute }) => {

  const [loading, setLoading] = useState(false);
  const [loadingDebounced] = useDebounce(loading, 500);

  const handleClick = async () => {
    setLoading(true);
    await onExecute();
    setLoading(false);
  }

  return (
    <IconButton
      tooltipPlacement="top"
      title={title}
      icon={icon}
      loading={loadingDebounced}
      disabled={disabled}
      onClick={handleClick}
    />
  );
}

export default Action;
